// Configuration for the 3 Camino infographic mobile-first landing pages.
// Each entry drives the CaminoInfografia component + SEO + sitemap.
// To swap the artwork/PDF, just replace these files in /public/camino/:
//   - infografia-{n}.png   → the hi-res image shown on screen (pinch-to-zoom)
//   - infografia-{n}.pdf   → the file downloaded by the "Descargar PDF" button
export const CAMINO_PAGES = [
  {
    slug: 'infografia-1',
    number: 1,
    greeting: '¡Buen Camino, peregrin@! 🌻',
    subline: 'Expresiones y vocabulario esencial en español',
    title: 'Infografía 1 · Expresiones y vocabulario del Camino de Santiago',
    seoDescription:
      'Infografía gratuita con expresiones y vocabulario esencial en español para peregrinos del Camino de Santiago. Descárgala en PDF y llévala contigo.',
    image: '/camino/infografia-1.jpg',
    pdf: '/camino/infografia-1.pdf',
    accent: '#F5A6A4',
  },
  {
    slug: 'infografia-2',
    number: 2,
    greeting: 'Palabras que te acompañan ⭐',
    subline: '10 frases útiles para tu día a día en el Camino',
    title: 'Infografía 2 · 10 frases útiles para el Camino de Santiago',
    seoDescription:
      '10 frases y expresiones útiles en español para peregrinos en el Camino de Santiago. Descarga gratis la infografía en PDF.',
    image: '/camino/infografia-2.jpg',
    pdf: '/camino/infografia-2.pdf',
    accent: '#A8D8EA',
  },
  {
    slug: 'infografia-3',
    number: 3,
    greeting: 'Ultreia et suseia! 🏛️',
    subline: 'Rutas, credencial y todo lo que debes saber',
    title: 'Infografía 3 · El Camino de Santiago: rutas e historia',
    seoDescription:
      'Todo sobre el Camino de Santiago: rutas, credencial, Compostela y consejos para el peregrino. Infografía gratuita en PDF.',
    image: '/camino/infografia-3.jpg',
    pdf: '/camino/infografia-3.pdf',
    accent: '#7DBDD9',
  },
];
